"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Alert = void 0;
const react_1 = __importStar(require("react"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const Modal_1 = __importDefault(require("../Modal/Modal"));
const ModalContent_1 = __importDefault(require("../Modal/ModalContent"));
const ModalFooter_1 = __importDefault(require("../Modal/ModalFooter"));
const Button_1 = __importDefault(require("../Util/Button"));
const enhancedFetch_1 = require("../../lib/enhancedFetch");
const PriceInput_1 = __importDefault(require("../Input/PriceInput"));
const TextInput_1 = __importDefault(require("../Input/TextInput"));
const NumberInput_1 = __importDefault(require("../Input/NumberInput"));
const helpers_1 = require("../../lib/helpers");
const JourneyAppContext_1 = require("../../contexts/JourneyAppContext");
const defaultButtons = [
    {
        label: 'Close',
        onClick: (e, setAlert) => { },
    },
];
exports.Alert = withJourney_1.default('j-alert', (props) => {
    const { alert, setAlert } = react_1.useContext(JourneyAppContext_1.JourneyAppContext);
    const [errors, setErrors] = react_1.useState({});
    const [message, setMessage] = react_1.useState('');
    const [buttons, setButtons] = react_1.useState(defaultButtons);
    const [inputs, setInputs] = react_1.useState([]);
    const [inputValues, setInputValues] = react_1.useState({});
    react_1.useEffect(() => {
        var _a, _b;
        if (!alert) {
            setErrors({});
            setMessage('');
            setButtons(defaultButtons);
        }
        else if (typeof alert === 'object' && 'label' in alert) {
            const alertInstance = alert;
            setErrors({});
            setMessage(alertInstance.label);
            setButtons((_a = alertInstance.buttons) !== null && _a !== void 0 ? _a : defaultButtons);
            const inputs = (_b = alertInstance.inputs) !== null && _b !== void 0 ? _b : [];
            setInputs(inputs);
            const inputValues = {};
            inputs.forEach((input) => {
                inputValues[input.propName] = input.initialValue;
            });
            setInputValues(inputValues);
        }
        else if (alert instanceof Error) {
            setMessage('');
            if ('response' in alert) {
                enhancedFetch_1.getResponseErrors(alert.response).then((errors) => {
                    setErrors(errors);
                }).catch(console.error);
            }
            else {
                setErrors({ main: alert.message });
            }
        }
        else if (typeof alert === 'string') {
            setErrors({});
            setMessage(helpers_1.parseTimeBlocks(alert));
        }
        else if (react_1.default.isValidElement(alert)) {
            setErrors({});
            setMessage(alert);
        }
    }, [alert]);
    const onButtonClickHandle = (button, e, setAlert) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const response = yield ((_a = button.onClick) === null || _a === void 0 ? void 0 : _a.call(button, e, setAlert, inputValues));
        if (response !== false) {
            setAlert(undefined);
        }
        return response;
    });
    const onClose = () => {
        var _a;
        setAlert('');
        if (typeof alert === 'object' && 'onClose' in alert) {
            (_a = alert === null || alert === void 0 ? void 0 : alert.onClose) === null || _a === void 0 ? void 0 : _a.call(alert);
        }
    };
    return (react_1.default.createElement(Modal_1.default, Object.assign({ positionAt: "center" }, props, { isOpen: !!alert, onClose: onClose }),
        react_1.default.createElement(ModalContent_1.default, null,
            message ? react_1.default.createElement(react_1.default.Fragment, null, message) : null,
            react_1.default.createElement("div", { className: "j-alert-inputs" }, inputs.map((input) => {
                const value = inputValues[input.propName];
                const onChange = (e) => setInputValues((prevInputValues) => (Object.assign(Object.assign({}, prevInputValues), { [input.propName]: input.type === 'price' ? e.target.value * 100 : e.target.value })));
                if (input.type === 'price') {
                    return (react_1.default.createElement(PriceInput_1.default, { key: input.propName, value: value, onChange: onChange }));
                }
                if (input.type === 'number') {
                    return (react_1.default.createElement(NumberInput_1.default, { key: input.propName, value: value, onChange: onChange }));
                }
                return (react_1.default.createElement(TextInput_1.default, { key: input.propName, value: value, onChange: onChange }));
            })),
            react_1.default.createElement("ul", null, Object.keys(errors !== null && errors !== void 0 ? errors : {}).map((key) => react_1.default.createElement("li", { key: key }, errors[key])))),
        react_1.default.createElement(ModalFooter_1.default, null, buttons.map((button) => (react_1.default.createElement(Button_1.default, { key: button.label, onClick: (e) => __awaiter(void 0, void 0, void 0, function* () { return onButtonClickHandle(button, e, setAlert); }) }, button.label))))));
});
